import { render } from "./UserReports.vue?vue&type=template&id=5f90daba"
import script from "./UserReports.vue?vue&type=script&lang=js"
export * from "./UserReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reports/UserReports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f90daba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f90daba', __exports__)) {
    api.reload('5f90daba', __exports__)
  }
  
  module.hot.accept("./UserReports.vue?vue&type=template&id=5f90daba", () => {
    api.rerender('5f90daba', render)
  })

}


export default __exports__